<template>
  <form data-vv-scope="login">
    <div class="number-prefix">
      <input
        class="col-12 form-control login-signup-input"
        type="text"
        placeholder="Email"
        v-validate="'required|email'"
        data-ismobileonly="false"
        name="email"
        v-model="email"
        :class="{ 'is-invalid': errors.has('login.email') && showLoginError}"
        id="login-form-email"
								data-test="loginFormEmailInput"
      >
      <div
        class="invalid-feedback"
        v-if="(errors.has('login.email') && showLoginError)"
        id="login-form-email-error"
								data-test="loginFormEmailInputError"
      >
        {{ errors.first('login.email') }}
      </div>
      <input
        class="col-12 form-control login-signup-input mt-2 mb-2"
        type="password"
        placeholder="Password"
        data-ismobileonly="false"
        name="password"
        v-model="password"
        id="login-form-password"
        :class="{ 'is-invalid': errors.has('login.password') && showLoginError}"
        v-validate="'required|min:6'"
        ref="password"
								data-test="loginFormPsswrdInput"
      >
      <div
        class="invalid-feedback"
        v-if="(errors.has('login.password') && showLoginError)"
        id="login-form-password-error"
								data-test="loginFormPsswrdInputError"
      >
        {{ errors.first('login.password') }}
      </div>
      <p class="terms"
									data-test="loginFormPara1"
									id="loginFormPara1">
        By continuing, you agree to {{siteName}}
        <router-link to="/pages/terms"
																					data-test="loginFormLink1"
																					id="loginFormLink1">
          Terms and Conditions of Use
        </router-link>
        and
        <router-link to="/pages/privacy"
																					data-test="loginFormLink2"
																					id="loginFormLink2">
          Privacy Notice
        </router-link>.
      </p>
      <a
        href="#"
        @click.prevent="openForgotPasswordPopUp()"
        id="login-form-forgot-psswrd-link"
								data-test="loginFormLink3"
      >
        Forgot Password?
      </a>
      <!--<a href="#"-->
      <!--data-toggle="modal"-->
      <!--data-target="#forgotpswd-modal"-->
      <!--@click.prevent="openForgotPasswordPopUp()"-->
      <!--id="login-form-forgot-psswrd-link"-->
      <!--&gt;-->
      <!--Forgot Password-->
      <!--</a>-->
    </div>
    <button
      class="ripplelink btn col-12 blue-btn continue-btn mt-2"
      v-loading="loading"
      @click.prevent="action('login')"
      id="login-form-btn"
						data-test="loginFormBtn"
    >
      {{buttonText}}
    </button>
  </form>
</template>

<script>
import { authenticationApi } from '@/services/ApiServices/authenticationApi'
import tenantSpecificNames from '@/commonJs/tenantSpecificNames'

export default {
	name: 'LoginForm',
	props: {
		buttonText: {
			type: String,
			default: 'Continue'
		}
	},
	data () {
		return {
			email: '',
			password: '',
			loading: '',
			showLoginError: false,
			siteName: 'Techgentsia'
		}
	},
	mounted () {
		this.siteName = tenantSpecificNames.tenantName
		this.$root.$on('LoginFormClear', () => {
			//
			this.email = ''
			this.password = ''
			if (this.$route.query.orderNumber) {
				this.$router.push('/')
			}
		})
	},
	methods: {
		login () {
			this.loading = authenticationApi.login({
				username: this.email,
				password: this.password
			}).then((res) => {
				// $('#login-modal').modal('hide');
				setTimeout(() => 1000)
				this.$emit('loginSuccess')
				this.resetFormData()
			}).catch((e) => {
				// login Api error case
			})
		},
		action (scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.showLoginError = false
					this.login()
				} else {
					this.showLoginError = true
				}
			})
		},
		resetFormData () {
			this.email = ''
			this.password = ''
			this.showLoginError = false
		},
		openForgotPasswordPopUp () {
			this.resetFormData()

			this.closerAnyOpenPopUps()
			this.$router.push('/forgotPassword')
		},
		closerAnyOpenPopUps () {
			//   $('#login-modal').modal('hide');
		}
	}
}
</script>
